import withApiData from "../withApiData";
import withOptimize from "./withOptimize";
import withMegaMenu from "./withMegaMenu";
import Header from "./Header";
import Placeholder from "./Placeholder";

export default withApiData(
  withOptimize(withMegaMenu(Header), Placeholder),
  Placeholder,
);
